import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, FloatingButton } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import ButtonInner from './ButtonInner';
import { Deactivation } from './Deactivation';
import { FREE_LINK_OFFSET, FreeLink, getFreeLinkHeight } from './FreeLink';

const SHADOW = '0 4px 12px 0 rgba(0, 0, 0, 0.3)';

const StyledWidgetButton = ({ position, ...buttonProps }) => {
  const settings = useSettings();
  const {
    positionType,
    buttonType,
    color,
    buttonIcon,
    buttonFilledColor,
    buttonColorOnHover,
    buttonTextColor: derivedButtonTextColor,
    buttonTextColorOnHover,
    shadow,
    borderColor,
    buttonLabel,
    buttonSecondLine,
    buttonLabelFont,
    displayFreeLink,
    displayDeactivation
  } = settings;

  const [derivedButtonColor, setDerivedButtonColor] = useState(color);
  const [finalButtonColor, setFinalButtonColor] = useState(derivedButtonColor);
  const [buttonTextColor, setButtonTextColor] = useState(
    derivedButtonTextColor
  );
  useEffect(() => {
    setDerivedButtonColor(color);
  }, [color]);

  useEffect(() => {
    setDerivedButtonColor(buttonFilledColor);
  }, [buttonFilledColor]);

  useEffect(() => {
    setFinalButtonColor(derivedButtonColor);
  }, [derivedButtonColor]);

  useEffect(() => {
    setButtonTextColor(derivedButtonTextColor);
  }, [derivedButtonTextColor]);

  const onMouseEnterHandler = () => {
    if (buttonType === 'outline') {
      setFinalButtonColor(buttonFilledColor);
    } else {
      setFinalButtonColor(buttonColorOnHover);
    }
    setButtonTextColor(buttonTextColorOnHover);
  };

  const onMouseLeaveHandler = () => {
    setFinalButtonColor(derivedButtonColor);
    setButtonTextColor(derivedButtonTextColor);
  };

  let finalButtonIcon;

  if (buttonIcon?.url) {
    finalButtonIcon = buttonIcon?.extension
      ? () => (
          <ButtonIconImg
            alt={buttonIcon?.name?.split('.')[0] ?? 'Button Icon'}
            src={buttonIcon.url}
          />
        )
      : { url: buttonIcon.url };
  }

  const iconOnly = !buttonLabel && !buttonSecondLine;

  const isBottomPosition = position.position.toLowerCase().includes('bottom');
  const freeLinkHeight = getFreeLinkHeight(settings);
  const additionalVerticalOffset = freeLinkHeight + FREE_LINK_OFFSET;

  if (positionType === 'floating') {
    return (
      <Deactivation>
        <FloatingButton
          {...buttonProps}
          style={displayDeactivation ? { pointerEvents: 'none' } : undefined}
          iconLeft={finalButtonIcon}
          iconOnly={iconOnly}
          font={buttonLabelFont}
          color={finalButtonColor}
          fontColor={buttonTextColor}
          borderColor={borderColor}
          withShadow={shadow}
          onMouseOver={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
          className="es-button-floating-button"
          slot={<FreeLink />}
          position={{
            ...position,
            verticalOffset:
              displayFreeLink && isBottomPosition
                ? position.verticalOffset + additionalVerticalOffset
                : position.verticalOffset
          }}
        >
          <ButtonInner />
        </FloatingButton>
      </Deactivation>
    );
  }

  return (
    <Button
      {...buttonProps}
      iconLeft={finalButtonIcon}
      iconOnly={iconOnly}
      font={buttonLabelFont}
      color={finalButtonColor}
      fontColor={buttonTextColor}
      borderColor={borderColor}
      style={{
        boxShadow: shadow ? SHADOW : undefined
      }}
      onMouseOver={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      <ButtonInner />
    </Button>
  );
};

export default StyledWidgetButton;

const ButtonIconImg = styled.img`
  padding: 0 !important;
  margin: 0 !important;
  position: relative !important;
`;
